import {Component, ElementRef, NgZone, OnInit, Output, ViewChild, EventEmitter, Input, OnChanges} from '@angular/core';

@Component({
  selector: 'app-place',
  templateUrl: './place.component.html',
  styleUrls: ['./place.component.scss']
})
export class PlaceComponent implements OnInit, OnChanges {

  @ViewChild('autocomplete') autocompleteElementRef: ElementRef;

  @Input('address') address: string;

  @Output() setPlace = new EventEmitter();

  constructor(private zone: NgZone) { }

  ngOnInit() {
    const autocomplete = new google.maps.places.Autocomplete(this.autocompleteElementRef.nativeElement, {
      types: ['address'],
      componentRestrictions: {country: ['us']}
    });

    autocomplete.addListener('place_changed', () => {
      this.zone.run(() => {
        const place = autocomplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          this.setPlace.next(null);
        } else {
          this.setPlace.next(place);
        }
      });
    });
  }

  ngOnChanges() {
    if (this.address) {
      this.autocompleteElementRef.nativeElement.value = this.address;
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/components/info-panel/place/place.component.ts